import React, {useEffect,useState,useRef} from 'react'
import errorsign from './error.svg';

import arrowSign from './arrow.svg';

import arrowSignw from './arroww.svg';
import { waitlist } from '../../apis';
import { useNavigate } from "react-router-dom";

export const validateEmail = (email) => {

     return  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
    
     
  };

const Steps = ({nameRef}) =>{
   

    const navigate = useNavigate();


    const [formData,setFormData] = useState({
        'name':"",
        'email':"",
        'brandName':"",
        photosCount:""
    })
    const [formDataError,setFormDataError] = useState({
        'name':"",
        'email':"",
        'brandName':"",
        photosCount:""
    })
    const [currentstep,setCurrentstep] = useState(1)
    const [formValid,setFormValid] = useState(0)
    const [disabled,setDisabled] = useState(false)
    
    const updateForm = (e) =>{
        setFormData({         
                ...formData,    
                [e.target.name]: e.target.value       
            
        })
     
    }
   
    const email = useRef()
    const brand = useRef()
    const pageEnd = useRef(null)
    useEffect(()=>{
        setCurrentstep(1)
    
      
    },[])


    useEffect(()=>{
        
       if(currentstep == 2){
        email.current.focus()
       }
       if(currentstep == 3){
        brand.current.focus()
       }
       if(currentstep == 4){
        setTimeout(()=>{
            pageEnd.current?.scrollIntoView({ behavior: "smooth",block: "end", inline: "nearest" })
        },200)
       }
    },[currentstep])


     const useComponentDidMount = () => {
        const ref = useRef();
        useEffect(() => {
          ref.current = true;
        }, []);
        return ref.current;
      };
    
    const isComponentMounted = useComponentDidMount();
    useEffect(()=>{
        if(isComponentMounted){
            checkValues()
        }

    },[formData])

    const validate = (updatestep = false) =>{
        if(checkValues()){
            if(!updatestep){
                setCurrentstep(currentstep+1)
                
            }
                
            else
                setCurrentstep(updatestep) 
            
        }
        
    }

    const checkValues = () =>{
        
        if(currentstep==1 ){
            if(formData.name == ""){
                setFormDataError({...formDataError,name:'Name cannot be blank'})
                setFormValid(0)
                return false
            }else{
               
                setFormDataError({...formDataError,name:''})
                return true
            }
        }
        if(currentstep==2 ){
          
            if(formData.email == "" ){
              
                setFormDataError({...formDataError,email:'Email cannot be blank'})
                setFormValid(0)
                return false
            }else if(!validateEmail(formData.email)){
                setFormDataError({...formDataError,email:'Please enter a valid Email ID'})
                setFormValid(0)
                return false
            }else{
                setFormDataError({...formDataError,email:''})
             
                return true
            }
          
        }
        if(currentstep==3  ){
          
            if(formData.brandName == ""){
                setFormDataError({...formDataError,brandName:'Company/Studio name cannot be blank'})
                setFormValid(0)
                return false
            }else{
                setFormDataError({...formDataError,brandName:''})
                return true
            }
        }
        if(currentstep==4 ){
            if(formData.photosCount == ""){
                setFormDataError({...formDataError,photosCount:'Please select an option'})
                setFormValid(0)
                return false
            }else{
                setFormDataError({...formDataError,photosCount:''})
                return true
            }
        }
    
        return true
        
    
    }
    const submitForm = () =>{
        var newData = {...formData,number:1111111111}
        setDisabled(true)
        if(checkValues()){
            //console.log(newData)

            waitlist(newData).then(()=>{
                navigate("/pre-register/complete");
            })
        }
        setDisabled(false)
    }

    return (
        <div>
            <div className=" step-list h-screen px-5  step-form flex items-center relative">
              
              
                <div className=" w-2/12 md:w-1/12 step-box mx-auto md:mx-10 md:h-[80%] ">
                    <div className={currentstep == 1?'sbox on':'sbox' } onClick={()=>validate(1)} ></div>
                    <div className={currentstep == 2?'sbox on':'sbox' } onClick={()=>validate(2)} ></div>
                    <div className={currentstep == 3?'sbox on':'sbox' } onClick={()=>validate(3)} ></div>
                    <div className={currentstep == 4?'sbox on':'sbox' } onClick={()=>validate(4)} ></div>
                </div>
                    {currentstep==1?(
                        <div className="form-1 w-10/12 md:w-8/12  ">
                            <h1 className="lg:text-[36px] font-bold text-[16px]">Tell us your name</h1>
                            <div className='relative mt-3 lg:mt-6'>
                                <input onKeyDown={e=>(e.key === 'Enter'?validate:null)} autoComplete="off"  ref={nameRef}    type='text' placeholder='First Name / Last Name' className={`input-bottom ${formDataError.name? 'error':(formData.name)&&'good' }`} name='name' value={formData.name} onChange={e=>updateForm(e)} />
                                {( formDataError.name || !formData.name) ?(
                                <span>
                                    {formDataError.name &&
                                <div className='errorbox text-red-400 font-light text-sm  flex'><img src={errorsign} className='mr-2' /> {formDataError.name}</div> }
                                <div  className='next-button'>
                                    <img src={arrowSign} />
                                </div>
                                </span>
                                ):(
                                <div onClick={()=>validate()}  className='next-button enabled'>
                                    <img src={arrowSignw} />
                                </div>   
                                )}
                                
                            </div>
                        </div>
                    ):currentstep==2?(
                        <div className="form-1 w-10/12 ">
                        <h1 className="lg:text-[36px] font-bold text-[16px]">Tell us your Email ID</h1>
                        <div className='relative mt-3 lg:mt-6'>
                            <input autoComplete="off"   autoFocus={true} type='text' ref={email} placeholder='john.doe@algomage.com' className={`input-bottom ${formDataError.email? 'error':(formData.email)&&'good'}`} value={formData.email} name='email' onChange={e=>updateForm(e)} />
                        {formDataError.email || !formData.email ?(
                        <span>
                        {formData.email &&
                        <div className='errorbox text-red-400 font-light text-sm  flex'><img src={errorsign} className='mr-2' /> {formDataError.email}</div>}
                        <div  className='next-button'>
                            <img src={arrowSign} />
                        </div>
                        </span>
                        ):(
                        <div onClick={()=>validate()}  className='next-button enabled'>
                            <img src={arrowSignw} />
                        </div>   
                        )}
                        
                        </div>
                    </div>
                        ):currentstep==3?(
                            <div className="form-1 w-10/12 ">
                            <h1 className="lg:text-[36px] font-bold text-[16px]">Tell us your company / studio name</h1>
                            <div className='relative mt-3 lg:mt-6'>
                                <input autoComplete="off"  ref={brand}  type='text' placeholder='Company Name / Studio Name' className={`input-bottom ${formDataError.brandName? 'error':(formData.brandName)&&'good'}`} value={formData.brandName} name='brandName' onChange={e=>updateForm(e)} />
                            {formDataError.brandName || !formData.brandName ?(
                            <span>
                            {formDataError.brandName && 
                            <div className='errorbox text-red-400 font-light text-sm  flex'><img src={errorsign} className='mr-2' /> {formDataError.brandName}</div>}
                            <div  className='next-button'>
                                <img src={arrowSign} />
                            </div>
                            </span>
                            ):(
                            <div onClick={()=>validate()}  className='next-button enabled'>
                                <img src={arrowSignw} />
                            </div>   
                            )}
                            
                            </div>
                        </div>
                    
                    ):currentstep==4?(
                        <div className="form-1 w-full h-full flex items-center ">
                        <div>
                        <h1 className="lg:text-[36px] font-bold text-[16px] pl-4">How many images do you shoot in a year?</h1>
                        <div className='relative  mt-8'>
                            <div  className='flex flex-wrap'>
                        
                                <input   type='radio' id='cb1' className='input-checkbox' value='Less than 100,000' name='photosCount' onChange={e=>updateForm(e)} />
                                <label htmlFor='cb1' className='checkbox-label'>
                                    Less than 100,000
                                </label>
                        
                                <input  id='cb2'  type='radio' className='input-checkbox' value='100,000 - 500,000' name='photosCount' onChange={e=>updateForm(e)} />
                                <label htmlFor='cb2' className='checkbox-label'>
                                    100,000 - 500,000
                                </label>
                            
                                <input   id='cb3' type='radio' className='input-checkbox' value='More than 500,000' name='photosCount' onChange={e=>updateForm(e)} />
                                <label htmlFor='cb3' className='checkbox-label'>
                                    More than 500,000
                                </label>
                            
                                <input   type='radio' id='cb4' className='input-checkbox' value='Not Sure' name='photosCount' onChange={e=>updateForm(e)} />
                                <label  htmlFor='cb4' className='checkbox-label'>
                                    Not Sure
                                </label>
                            </div>
                        {formDataError.photosCount?(
                
                        <div className='errorbox text-red-400 font-light text-sm  flex pl-3'><img src={errorsign} className='mr-2' /> {formDataError.photosCount}</div>
                    
                        ):null}
                        
                       
                        </div>
                        </div>
                        {(formData.photosCount  && formData.name && formData.email && formData.brandName ) ? 
                        (<button  className="buttons-gradient move-button m-0 mt-5 uppercase font-bold lg:text-[14px]  text-[10px]" onClick={submitForm} >Add me to the list</button>)
                        :
                        (<button  className="button-grey move-button m-0 mt-5 uppercase font-bold lg:text-[14px] text-[10px] " onClick={submitForm} disabled={true} >Add me to the list</button>)
                        }
                    </div>
                
                ):null}
            
              
                </div>
                <div  ref={pageEnd}>

                </div>
            
        </div>

    )
}

export default Steps